/**
 * Bellou Cart Drawer Enhancements
 *
 * - Progress: 3=2 deal (blijvend) · €10 cadeaucode bij €75 · gratis verzending bij €100
 * - Upsell strip (collapsible)
 * - Bar loopt op cart total richting €100
 */

(function () {
  'use strict';

  const DISCOUNT_THRESHOLD = 7500;    // €75 in cents
  const FREE_SHIP_THRESHOLD = 10000;  // €100 in cents
  const PREMIUM_UPSELL_THRESHOLD = 7500;

  function formatMoney(cents) {
    const euros = cents / 100;
    return '€' + euros.toFixed(2).replace('.', ',');
  }

  function buildProgressMessage(itemCount, currentTotal) {
    const itemsToNextFree = (3 - (itemCount % 3)) % 3;
    const justUnlockedDeal = itemCount > 0 && itemCount % 3 === 0;
    const hasDiscount = currentTotal >= DISCOUNT_THRESHOLD;
    const hasFreeShip = currentTotal >= FREE_SHIP_THRESHOLD;
    const eurosToDiscount = Math.max(0, DISCOUNT_THRESHOLD - currentTotal);
    const eurosToShip = Math.max(0, FREE_SHIP_THRESHOLD - currentTotal);
    const highlight = (text) => `<span class="bellou-progress__highlight">${text}</span>`;
    const itemsText = (n) => n === 1 ? '1 sieraad' : `${n} sieraden`;

    if (itemCount === 0) {
      return 'Kies er 3, betaal er 2 - de voordeligste is van ons';
    }
    if (itemCount === 1) {
      return `Nog ${highlight('2 sieraden')} voor de 3=2 deal`;
    }
    if (itemCount === 2) {
      return `Nog ${highlight('1 sieraad')} - dan is de voordeligste van ons`;
    }
    if (justUnlockedDeal && hasFreeShip) {
      return 'Alles unlocked: 3=2 deal · €10 cadeaucode · gratis verzending';
    }
    if (justUnlockedDeal && hasDiscount) {
      return `3=2 deal actief · €10 cadeaucode verdiend · nog ${highlight(formatMoney(eurosToShip))} voor verzending`;
    }
    if (justUnlockedDeal) {
      return `3=2 deal actief - nog ${highlight(formatMoney(eurosToDiscount))} voor €10 cadeaucode`;
    }
    if (hasFreeShip) {
      return `Nog ${highlight(itemsText(itemsToNextFree))} voor volgende 3=2 · alles unlocked`;
    }
    if (hasDiscount) {
      return `Nog ${highlight(itemsText(itemsToNextFree))} voor volgende 3=2 · nog ${highlight(formatMoney(eurosToShip))} voor verzending`;
    }
    return `Nog ${highlight(itemsText(itemsToNextFree))} voor volgende 3=2 · nog ${highlight(formatMoney(eurosToDiscount))} voor €10 cadeaucode`;
  }

  function updateProgressUI(itemCount, currentTotal) {
    const container = document.querySelector('[data-bellou-progress]') || document.querySelector('.bellou-progress');
    if (!container) return;

    container.dataset.itemCount = String(itemCount);
    container.dataset.currentTotal = String(currentTotal);

    const messageEl = container.querySelector('[data-progress-message]');
    if (messageEl) {
      messageEl.innerHTML = buildProgressMessage(itemCount, currentTotal);
    }

    const overall = Math.min(100, (currentTotal / FREE_SHIP_THRESHOLD) * 100);
    const barEl = container.querySelector('[data-progress-bar]');
    if (barEl) {
      barEl.style.width = overall + '%';
    }

    const dealMarker = container.querySelector('[data-marker-deal]');
    const discountMarker = container.querySelector('[data-marker-discount]');
    const shipMarker = container.querySelector('[data-marker-ship]');
    if (dealMarker) {
      dealMarker.classList.toggle('is-reached', itemCount >= 3);
    }
    if (discountMarker) {
      discountMarker.classList.toggle('is-reached', currentTotal >= DISCOUNT_THRESHOLD);
    }
    if (shipMarker) {
      shipMarker.classList.toggle('is-reached', currentTotal >= FREE_SHIP_THRESHOLD);
    }
  }

  let lastWasPremium = null;

  function checkPremiumCrossing(currentTotal) {
    const isPremium = currentTotal >= PREMIUM_UPSELL_THRESHOLD;
    if (lastWasPremium === null) {
      lastWasPremium = isPremium;
      return false;
    }
    if (lastWasPremium !== isPremium) {
      lastWasPremium = isPremium;
      return true;
    }
    return false;
  }

  async function fetchAndUpdateCart() {
    try {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) throw new Error('Cart fetch failed: ' + response.status);
      const cart = await response.json();

      updateProgressUI(cart.item_count, cart.total_price);

      if (checkPremiumCrossing(cart.total_price)) {
        refreshCartDrawer();
      }

      return cart;
    } catch (err) {
      console.warn('[Bellou] Could not fetch cart:', err);
      return null;
    }
  }

  async function refreshCartDrawer() {
    try {
      const response = await fetch(window.location.pathname + '?section_id=' + getCartSectionId(), {
        headers: { 'Accept': 'text/html' }
      });
      if (!response.ok) return;
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newUpsell = doc.querySelector('.bellou-upsell');
      const currentUpsell = document.querySelector('.bellou-upsell');
      if (newUpsell && currentUpsell) {
        currentUpsell.replaceWith(newUpsell);
      } else if (newUpsell && !currentUpsell) {
        const items = document.querySelector('.cart-drawer__items');
        if (items && items.parentNode) {
          items.parentNode.insertBefore(newUpsell, items.nextSibling);
        }
      } else if (!newUpsell && currentUpsell) {
        currentUpsell.remove();
      }
    } catch (err) {
      console.warn('[Bellou] Could not refresh upsell:', err);
    }
  }

  function getCartSectionId() {
    const el = document.querySelector('cart-items-component[data-section-id]');
    return el ? el.dataset.sectionId : '';
  }

  async function handleUpsellAdd(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.setAttribute('data-loading', 'true');
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: [getCartSectionId()].filter(Boolean).join(',')
        })
      });

      if (!response.ok) throw new Error('Add to cart failed: ' + response.status);

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      await fetchAndUpdateCart();
    } catch (err) {
      console.warn('[Bellou] Could not add upsell item:', err);
      button.removeAttribute('data-loading');
      button.disabled = false;
    }
  }

  function handleUpsellToggle(toggle) {
    const upsell = toggle.closest('[data-bellou-upsell]');
    if (!upsell) return;
    const isCollapsed = upsell.getAttribute('data-collapsed') === 'true';
    upsell.setAttribute('data-collapsed', isCollapsed ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', isCollapsed ? 'true' : 'false');
    try {
      localStorage.setItem('bellou_upsell_collapsed', isCollapsed ? 'false' : 'true');
    } catch (e) {}
  }

  function restoreUpsellState() {
    try {
      const saved = localStorage.getItem('bellou_upsell_collapsed');
      if (saved === 'false') {
        const upsell = document.querySelector('[data-bellou-upsell]');
        if (upsell) {
          upsell.setAttribute('data-collapsed', 'false');
          const toggle = upsell.querySelector('[data-bellou-upsell-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
        }
      }
    } catch (e) {}
  }

  function init() {
    fetchAndUpdateCart();

    document.addEventListener('click', (event) => {
      const addBtn = event.target.closest('[data-bellou-upsell-add]');
      if (addBtn) {
        event.preventDefault();
        event.stopPropagation();
        handleUpsellAdd(addBtn);
        return;
      }

      const toggleBtn = event.target.closest('[data-bellou-upsell-toggle]');
      if (toggleBtn) {
        event.preventDefault();
        event.stopPropagation();
        handleUpsellToggle(toggleBtn);
        return;
      }
    });

    const cartEvents = ['cart:updated', 'cart:refresh', 'cart-update', 'cart:change'];
    cartEvents.forEach((eventName) => {
      document.addEventListener(eventName, () => {
        setTimeout(() => {
          fetchAndUpdateCart();
          restoreUpsellState();
        }, 100);
      });
    });

    document.addEventListener('dialog:opened', (event) => {
      if (event.target.closest('cart-drawer-component')) {
        fetchAndUpdateCart();
        restoreUpsellState();
      }
    });

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      const observer = new MutationObserver(() => {
        if (window._bellouMutationFrame) return;
        window._bellouMutationFrame = requestAnimationFrame(() => {
          window._bellouMutationFrame = null;
          fetchAndUpdateCart();
          restoreUpsellState();
        });
      });
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }

    restoreUpsellState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();